import type { ComponentProps } from 'react';

const ArrowLeft = (props: ComponentProps<'svg'> & { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <path
      stroke="#55657D"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M35.455 20.33H4.545"
    />
    <path
      stroke="#55657D"
      strokeLinecap="square"
      strokeMiterlimit={10}
      strokeWidth={2}
      d="M15.785 31.57 4.545 20.33l11.24-11.24"
    />
  </svg>
);

export default ArrowLeft;
